<div class="dialog confirm-dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="onClose()">close</mat-icon>
  <div mat-dialog-title>
    <h1 l10nTranslate>shared.alert</h1>
  </div>

  <div mat-dialog-content class="confirm-container">
    <!-- VIEW MODE -->
    <div class="viewmode">
      <span><mat-icon class="mat-icon" svgIcon="alert-icon"></mat-icon></span>
      <span id="e2e-description">
        <span class="message">
          {{ 'shared.changesHaveBeenMadeReportGenerated' | xTranslate }}
          {{ 'shared.clickButtonRefreshReportUsingUpdatedValues' | xTranslate }}
          <span *ngIf="context === 'report'" class="keep-old-values">{{
            'shared.orClickXToKeepOldValues' | xTranslate
          }}</span>
          <ng-container *ngIf="context !== 'clipboard'; else clipboardMessage"></ng-container>
        </span>
      </span>
    </div>
    <div mat-dialog-actions>
      <button mat-flat-button color="primary" (click)="onUpdate()" l10nTranslate>shared.refresh</button>
    </div>
  </div>
  <ng-template #clipboardMessage>
    {{ 'shared.clipboardMessageOutDated' | xTranslate }}
  </ng-template>
</div>
